import GroupConfigurationRole from '@/assets/data/GroupConfigurationRole'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Input } from '@/Components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select'
import GroupConfigurationService from '@/Service/GroupConfigurationService'
import UserService from '@/Service/UserService'
import React, { useEffect, useReducer } from 'react'
import { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import { Checkbox } from '@/Components/ui/checkbox'
import { useLocation, useNavigate } from 'react-router-dom'
import { PaginationWithLinks } from '@/Components/Common/Pagination'
import { Button } from '@/Components/ui/button'
import { Plus, Save, Trash2 } from 'lucide-react'
import CustomSelect from '@/Components/Common/CustomSelect'
import { toast } from 'react-toastify'
import MultipleSelector from '@/Components/Common/MultipleSelector'
import Constent from '@/utils/constent'

const AssignmentConfiguration = ({}) => {
    const location = useLocation()
    const navigate = useNavigate()
    const url = new URLSearchParams(location.search)

    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            groups: [],
            totalAssessmentCount : 0,
            startRowSerial : 1,
            payorTypes: [],
            assessmentTypes: [],
            assignmentConfigurations: [],
            employeeConfigurationGroupWise: {},
            groupAllEmployeeChecked: {},
            employee: [],
            isOpen: false,
            searchFilter: {
                limit: url.get('limit') && url.get('limit') != 'undefined' ? url.get('limit') : Constent.PAGINATION_SIZE,
                page: 1,
                role: url.get('assignment_config_role') && url.get('assignment_config_role') != 'undefined' ? url.get('assignment_config_role') : '',
                employee: {
                    employee_email: url.get('employee_email') || '',
                    employee_name: url.get('employee_name') || '',
                },
                group_name: url.get('group_name') || '',
            },
            priorityChangeEvent: 0,
        }
    )

    const getGroupConfigurations = async () => {
        try {
            const resp = await GroupConfigurationService.getGroupConfigurations()
            if (resp.data.success) {
                updateEvent({ groups: resp.data.data })
            }
        } catch (err) {}
    }
    const getUserByRoles = async () => {
        try {
            const resp = await UserService.getUsersByRole()
            if (resp.data.success) {
                updateEvent({ employee: resp.data.data })
            }
        } catch (err) {
            console.log('err', err)
        }
    }
    const getAssignmentConfigurations = async () => {
        updateEvent({ isDataFetching: true })
        try {
            let postBody = {
                ...event.searchFilter,
                ...event.searchFilter.employee,
            }
            delete postBody.employee, delete postBody.employee_name
            const resp = await GroupConfigurationService.getAssignmentConfigurations(postBody)
            if (resp.data.success) {
                updateEvent({
                    assignmentConfigurations:
                        resp.data.data?.assignment_configurations && resp.data.data?.assignment_configurations.length > 0
                            ? resp.data.data?.assignment_configurations.map((configurations) => {
                                  configurations['functionality'].map((functionality) => {
                                      functionality['checkbox'] = false
                                      return functionality
                                  })
                                  return configurations
                              })
                            : [],
                    payorTypes: resp.data.data?.payor_type_list || [],
                    assessmentTypes: resp.data.data?.assessment_type_list || [],
                    totalAssessmentCount : resp.data.data?.total_items || 0,
                    startRowSerial : resp.data.data?.starting_row_number || 1
                })
            }
        } catch (err) {
            console.log('err', err)
        }
        updateEvent({ isDataFetching: false })
    }

    const updateSampling = async (data) => {
        updateEvent({ isDataFetching: true })
        try {
            const resp = await GroupConfigurationService.updateAssignmentConfigurationSampling(data)
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }

    useEffect(() => {
        getGroupConfigurations()
        getUserByRoles()
    }, [])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            searchFilter: {
                ...event.searchFilter,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getAssignmentConfigurations()
        url.set('employee_email', event.searchFilter.employee.employee_email)
        url.set('employee_name', event.searchFilter.employee.employee_name)
        url.set('assignment_config_role', event.searchFilter.assignment_config_role)
        url.set('group_name', event.searchFilter.group_name)
        navigate(`${location.pathname}?${url.toString()}`, { replace: true })
    }, [event.searchFilter.employee.employee_email, event.searchFilter.assignment_config_role, event.searchFilter.group_name, event.searchFilter.limit, event.searchFilter.page])

    const handleFunctionalitySave = async (configuration) => {
        updateEvent({ isDataFetching: true })
        try {
            let functionality = configuration.functionality
            let targets = configuration.target
            let newSamplings = []
            targets.forEach((target) => {
                if (target['sampling'] > target['target']) {
                    newSamplings.push({ name: target.name, sampling: target.sampling })
                }
            })
            let prevAssessmentType = ''
            let allPayorTypeCount = 1
            const groupMap = new Map()
            functionality.forEach((table) => {
                if (table['payor_type'].includes('All Payor Types')) {
                    groupMap.set('All Payor Types' + '-' + table['assessment_type'], 1)
                }
            })
            functionality.forEach((row) => {
                let { payor_type = [], assessment_type, target } = row
                payor_type = Array.isArray(payor_type) ? payor_type : payor_type.split(',')
                if (!payor_type.length) {
                    toast.error('Payor Type is required')
                    throw Error('Payor Type is required')
                }
                if (!assessment_type) {
                    toast.error('Assessment is required')
                    throw Error('Assessment is required')
                }

                if (!target || target == 0) {
                    toast.error('Target should not be empty or 0')
                    throw Error('Target should not be empty or 0')
                }

                // Reset count when assessment_type changes
                if (prevAssessmentType !== assessment_type) {
                    allPayorTypeCount = 1
                    prevAssessmentType = assessment_type
                }

                payor_type.forEach((type) => {
                    const key = `${type}-${assessment_type}`
                    const allKey = `All Payor Types-${assessment_type}`

                    if (type === 'All Payor Types' && allPayorTypeCount === 1) {
                        allPayorTypeCount++
                        return
                    }

                    if (groupMap.has(key)) {
                        groupMap.set(key, groupMap.get(key) + 1)
                    } else {
                        // If 'All Payor Types' exists, bump its count
                        if (groupMap.has(allKey)) {
                            groupMap.set(allKey, groupMap.get(allKey) + 1)
                        }
                        groupMap.set(key, 1)
                    }
                })
            })
            // Second pass: check for conflicts and duplicates
            functionality.forEach((row, i) => {
                let { payor_type = [], assessment_type } = row
                const allKey = `All Payor Types-${assessment_type}`
                payor_type = Array.isArray(payor_type) ? payor_type : payor_type.split(',')
                if (groupMap.has(allKey) && groupMap.get(allKey) > 1) {
                    toast.error(`We found 'All Payor Types' linked to the '${assessment_type}' assessment. Please remove the extra ones.`)
                    throw Error(`We found 'All Payor Types' linked to the '${assessment_type}' assessment. Please remove the extra ones.`)
                }

                for (const type of payor_type) {
                    const key = `${type}-${assessment_type}`
                    if (groupMap.has(key) && groupMap.get(key) > 1) {
                        toast.error(`Duplicate Group Functionality Configuration found: ${key}`)
                        throw Error(`Duplicate Group Functionality Configuration found: ${key}`)
                    }
                }
                functionality[i]['payor_type'] = payor_type.join(',')
            })
            let postData = {
                parent_name: configuration.name,
                functionality_data: functionality,
            }
            const resp = await GroupConfigurationService.saveAssignmentConfigurationsfunctionality(postData)
            if (resp.data.success) {
                getAssignmentConfigurations()
            }
        } catch (err) {
            console.log('err : ', err)
        }
        updateEvent({ isDataFetching: false })
    }

    const handleAddFunctionalityRow = (parentName) => {
        updateEvent({
            assignmentConfigurations: event.assignmentConfigurations.map((configuration, cIndex) => {
                if (configuration.name == parentName) {
                    configuration['functionality'] = [
                        ...configuration['functionality'],
                        {
                            payor_type: [],
                            assessment_type: '',
                            target: 0,
                            achived_target: 0,
                            enable: true,
                        },
                    ]
                }
                return configuration
            }),
        })
    }

    return (
        <div>
            <div className="w-full my-2 grid grid-cols-3 gap-3 ">
                <SearchableDropdown
                    selectedVal={event.searchFilter.employee.employee_name}
                    options={event.employee}
                    label="email"
                    handleChange={(val) => {
                        updateEvent({
                            searchFilter: {
                                ...event.searchFilter,
                                employee: {
                                    employee_email: val?.email || '',
                                    employee_name: val?.full_name || '',
                                },
                            },
                        })
                    }}
                    className=" w-full"
                    placeholder="Employee Email"
                    type="GET_OBJ"
                    searchFilter={{}}
                />
                <CustomSelect
                    value={event.searchFilter.assignment_config_role}
                    onChange={(e) => {
                        updateEvent({
                            searchFilter: {
                                ...event.searchFilter,
                                assignment_config_role: e.target.value,
                            },
                        })
                    }}
                    options={GroupConfigurationRole}
                    optionValue="key"
                    label="value"
                    placeHolder="Role"
                />
                <SearchableDropdown
                    selectedVal={event.searchFilter.group_name}
                    options={event.groups}
                    label="group_name"
                    handleChange={(val) => {
                        updateEvent({
                            searchFilter: {
                                ...event.searchFilter,
                                group_name: val,
                            },
                        })
                    }}
                    className="w-full"
                    placeholder="Groups"
                    searchFilter={{}}
                />
            </div>
            <div className="mt-4 flex flex-col gap-5 overflow-auto max-h-[calc(100vh-285px)] border p-2 rounded-md shadow-inner">
                {event.assignmentConfigurations.length > 0
                    ? event.assignmentConfigurations.map((configuration, configIndex) => (
                          <div key={configuration.name} className="border shadow-blue-100 border-gray-300  rounded-md shadow-lg">
                              <div className="py-1 pt-2 px-2 flex justify-around items-center bg-blue-200 rounded-t-md border-b">
                                  <div className="flex gap-1 justify-center items-center flex-col ">
                                      <span className="text-gray-600 font-bold text-[14px]">Employee Name</span>
                                      <span className="text-gray-600 text-[12px]">{configuration?.employee_name}</span>
                                  </div>
                                  <div className="flex gap-1 justify-center items-center flex-col ">
                                      <span className="text-gray-600 font-bold text-[14px]">Role</span>
                                      <span className="text-gray-600 text-[12px]">{configuration?.role}</span>
                                  </div>
                                  <div className="flex gap-1 justify-center items-center flex-col ">
                                      <span className="text-gray-600 font-bold text-[14px]">Group</span>
                                      <span className="text-gray-600 text-[12px]">{configuration?.group}</span>
                                  </div>
                                  <div className="flex gap-1 justify-center items-center flex-col ">
                                      <span className="text-gray-600 font-bold text-[14px]">Daily Target</span>
                                      <span className="text-gray-600 text-[12px]">{configuration?.chart_target}</span>
                                  </div>
                                  <div className="flex gap-1 justify-center items-center flex-col ">
                                      <span className="text-gray-600 font-bold text-[14px]">Achieved Chart Target</span>
                                      <span className="text-gray-600 text-[12px]">{configuration?.total_achieved_target}</span>
                                  </div>
                              </div>
                              <div className="my-4 px-8 flex flex-col gap-5">
                                  <Table className="shadow-md">
                                      <TableHeader>
                                          <TableRow className="bg-gray-200">
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center py-2">Maximum Target</TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center py-2">Pending Target</TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center py-2">Achieved Target</TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center py-2">Sampling</TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center py-2">
                                                  Achieved Sampling
                                              </TableHead>
                                          </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                          {configuration.target.length > 0 &&
                                              configuration.target.map((target, targetIndex) => (
                                                  <TableRow key={target.name}>
                                                      <TableCell className="text-center text-[13px] py-2">{target.target}</TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">{target.pending_target}</TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">{target.achived_target}</TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <Input
                                                              type="number"
                                                              className="text-center"
                                                              value={target.sampling}
                                                              onChange={(e) => {
                                                                  let currentSampling = e.target.value
                                                                  if (currentSampling > target.target) {
                                                                      toast.warning('Sampling Cannot be More than target')
                                                                      currentSampling = ''
                                                                  }
                                                                  let postData = {
                                                                      name: '',
                                                                      sampling: '',
                                                                  }
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['target'].map((_, tIndex) => {
                                                                                      if (tIndex == targetIndex) {
                                                                                          let prevSampling =
                                                                                              configuration['target'][tIndex]['sampling']
                                                                                          configuration['target'][tIndex]['sampling'] =
                                                                                              currentSampling == ''
                                                                                                  ? configuration['target'][tIndex]['prevSampling']
                                                                                                  : currentSampling
                                                                                          configuration['target'][tIndex]['prevSampling'] =
                                                                                              prevSampling
                                                                                          postData['name'] = configuration['target'][tIndex]['name']
                                                                                          postData['sampling'] =
                                                                                              configuration['target'][tIndex]['sampling']
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                                  if (postData.name && postData.sampling && currentSampling !== '') {
                                                                      updateSampling(postData)
                                                                  }
                                                              }}
                                                          />
                                                      </TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">{target.achieved_sampling}</TableCell>
                                                  </TableRow>
                                              ))}
                                      </TableBody>
                                  </Table>
                                  <Table className="shadow-md w-full">
                                      <TableHeader>
                                          <TableRow className="bg-gray-200">
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[5%] py-2">
                                                  <Checkbox
                                                      className="border"
                                                      checked={
                                                          configuration.functionality.length > 0 &&
                                                          configuration.functionality.every((func) => func.checkbox)
                                                      }
                                                      onCheckedChange={(isChecked) => {
                                                          updateEvent({
                                                              assignmentConfigurations: event.assignmentConfigurations.map(
                                                                  (configuration, cIndex) => {
                                                                      if (cIndex == configIndex) {
                                                                          configuration['functionality'].map((_, fIndex) => {
                                                                              configuration['functionality'][fIndex]['checkbox'] = isChecked
                                                                          })
                                                                      }
                                                                      return configuration
                                                                  }
                                                              ),
                                                          })
                                                      }}
                                                  />
                                              </TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[40%] py-2">
                                                  Payor Type
                                              </TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[20%] py-2">
                                                  Assessment Type
                                              </TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[10%] py-2">Target</TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[15%] py-2">
                                                  Achieved Target
                                              </TableHead>
                                              <TableHead className="font-bold text-[13px] text-gray-600 text-center w-[10%] py-2">Enabled</TableHead>
                                          </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                          {configuration.functionality.length > 0 &&
                                              configuration.functionality.map((functionality, funcIndex) => (
                                                  <TableRow key={functionality.name}>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <Checkbox
                                                              checked={functionality.checkbox}
                                                              onCheckedChange={(isChecked) => {
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['functionality'].map((_, fIndex) => {
                                                                                      if (fIndex == funcIndex) {
                                                                                          configuration['functionality'][fIndex]['checkbox'] =
                                                                                              isChecked
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                              }}
                                                          />
                                                      </TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <MultipleSelector
                                                              placeHolder="Payor Type"
                                                              selectedValue={
                                                                  Array.isArray(functionality.payor_type)
                                                                      ? functionality.payor_type
                                                                      : functionality.payor_type.split(',')
                                                              }
                                                              onChange={(val) => {
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['functionality'].map((_, fIndex) => {
                                                                                      if (fIndex == funcIndex) {
                                                                                          configuration['functionality'][fIndex]['payor_type'] = val
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                              }}
                                                              items={event.payorTypes}
                                                              label="name"
                                                              className=""
                                                          />
                                                      </TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <SearchableDropdown
                                                              selectedVal={functionality.assessment_type}
                                                              options={event.assessmentTypes}
                                                              label="name"
                                                              handleChange={(val) => {
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['functionality'].map((_, fIndex) => {
                                                                                      if (fIndex == funcIndex) {
                                                                                          configuration['functionality'][fIndex]['assessment_type'] =
                                                                                              val
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                              }}
                                                              className="w-full text-center "
                                                              placeholder="Payor Type"
                                                              searchFilter={{}}
                                                          />
                                                      </TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <Input
                                                              className=" text-center"
                                                              value={functionality.target}
                                                              onChange={(e) => {
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['functionality'].map((_, fIndex) => {
                                                                                      if (fIndex == funcIndex) {
                                                                                          configuration['functionality'][fIndex]['target'] =
                                                                                              e.target.value
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                              }}
                                                          />
                                                      </TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">{functionality.achived_target}</TableCell>
                                                      <TableCell className="text-center text-[13px] py-2">
                                                          <Checkbox
                                                              checked={Boolean(functionality.enable)}
                                                              onCheckedChange={(isChecked) => {
                                                                  updateEvent({
                                                                      assignmentConfigurations: event.assignmentConfigurations.map(
                                                                          (configuration, cIndex) => {
                                                                              if (cIndex == configIndex) {
                                                                                  configuration['functionality'].map((_, fIndex) => {
                                                                                      if (fIndex == funcIndex) {
                                                                                          configuration['functionality'][fIndex]['enable'] =
                                                                                              Number(isChecked)
                                                                                      }
                                                                                  })
                                                                              }
                                                                              return configuration
                                                                          }
                                                                      ),
                                                                  })
                                                              }}
                                                          />
                                                      </TableCell>
                                                  </TableRow>
                                              ))}
                                      </TableBody>
                                      <TableFooter>
                                          <TableRow>
                                              <TableCell colSpan={7}>
                                                  <div className="flex justify-between my-2">
                                                      <div className="flex gap-2">
                                                          <Button
                                                              className="hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                                                              onClick={() => handleAddFunctionalityRow(configuration.name)}
                                                          >
                                                              <Plus />
                                                              Add
                                                          </Button>
                                                          {configuration.functionality.length > 0 &&
                                                              configuration.functionality.some((func) => func.checkbox) && (
                                                                  <Button
                                                                      className="bg-primary-red font-normal text-[12px]"
                                                                      onClick={() => {
                                                                          updateEvent({
                                                                              assignmentConfigurations: event.assignmentConfigurations.map(
                                                                                  (configuration, cIndex) => {
                                                                                      if (cIndex == configIndex) {
                                                                                          let newFunc = configuration['functionality'].filter(
                                                                                              (func) => !func.checkbox
                                                                                          )
                                                                                          configuration['functionality'] = newFunc
                                                                                      }
                                                                                      return configuration
                                                                                  }
                                                                              ),
                                                                          })
                                                                      }}
                                                                  >
                                                                      <Trash2 />
                                                                      Delete
                                                                  </Button>
                                                              )}
                                                      </div>
                                                      <div>
                                                          <Button
                                                              className="bg-primary-purpal hover:bg-primary-purpal px-4"
                                                              onClick={() => handleFunctionalitySave(configuration)}
                                                          >
                                                              <Save />
                                                              Save
                                                          </Button>
                                                      </div>
                                                  </div>
                                              </TableCell>
                                          </TableRow>
                                      </TableFooter>
                                  </Table>
                              </div>
                          </div>
                      ))
                    : null}
            </div>
            <PaginationWithLinks
                totalCount={event.totalAssessmentCount}
                pageSizeRange={[20, 50, 100]}
                startSerial={event.startRowSerial}
                endSerial={(parseInt(event.assignmentConfigurations.length) + parseInt(event.startRowSerial)) - 1}
                showCountLable={true}
                onPageCountChange={(limit) => {
                    updateEvent({
                        searchFilter: {
                            ...event.searchFilter,
                            limit,
                        },
                    })
                }}
            />
        </div>
    )
}

export default AssignmentConfiguration
